import React, { useEffect, useRef } from 'react';
import ImageSlider from './ImageSlider';
import { Contact } from './Contact';
import mypic from '../assets/img/mypic.jpg';
import './landing.css';
import book from '../assets/img/book.png';
import home from '../assets/img/home.mp4';
import profile from '../assets/img/profile.png';
import tandc from '../assets/img/tandc.mp4';
import help from '../assets/img/help.mp4';
import form1 from '../assets/img/form1.png';
import form2 from '../assets/img/form2.png';
import smoothscroll from 'smoothscroll-polyfill';
import Footer from './Footer';
import Skills from './Skills';
import Typed from 'typed.js';
import login from '../assets/img/login.png';
import signup from '../assets/img/signup.png';
import landing from '../assets/img/landing.png';
import s1 from '../assets/img/s1.png';
import s2 from '../assets/img/s2.png';
import s3 from '../assets/img/s3.png';
import s4 from '../assets/img/s4.png';
import s5 from '../assets/img/s5.png';
import s6 from '../assets/img/s6.png';
import s7 from '../assets/img/s7.png';
import ShinyText from '../components/constants/projectnames';
import VariableProximity from '../components/constants/smalldesc';





const Landing = () => {
  const projectsRef = useRef(null);
  const skillsRef = useRef(null);
  const aboutMeRef = useRef(null);
  const contactRef = useRef(null);
  const typedInstance = useRef(null);
  const containerRef = useRef(null);



  useEffect(() => {
    initializeTypingEffect();

    return () => {
      if (typedInstance.current) {
        typedInstance.current.destroy();
      }
    };
  }, []);

  const initializeTypingEffect = () => {
    if (typedInstance.current) {
      typedInstance.current.destroy(); // Destroy existing instance if any
    }

    typedInstance.current = new Typed('.myname1', {
      strings: ["Hi, I'm Darshan Nakshatri "],
      typeSpeed: 100,
    });
  };

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
    if(ref===aboutMeRef) {
      window.scrollTo(0, 0);
      initializeTypingEffect();
    }
  };

  const slides = [
    { url: landing, title: 'landing', description: 'This is a login page' },
    { url: signup, title: 'signin', description: 'This is a signin page' },
    { url: login, title: 'login', description: 'This is a login page' },
    { url: home, title: 'Home', description: 'This is a home page' },
    { url: book, title: 'Book', description: 'This is a book page' },
    { url: profile, title: 'Profile', description: 'This is a profile page' },
    { url: tandc, title: 'Terms and Conditions', description: 'This is a terms and conditions page' },
    { url: help, title: 'Help', description: 'This is a help page' },
  ];
  const slides2 = [
    { url: form1, title: 'form1', description: 'This is a form page' },
    { url: form2, title: 'form1', description: 'This is a form page' },
  ];
  const slides3 = [
    { url: s1, title: 's1', description: 'This is a s1 page' },
    { url: s2, title: 's2', description: 'This is a s2 page' },
    { url: s3, title: 's3', description: 'This is a s3 page' },
    { url: s4, title: 's4', description: 'This is a s4 page' },
    { url: s5, title: 's5', description: 'This is a s5 page' },
    { url: s6, title: 's6', description: 'This is a s6 page' },
    { url: s7, title: 's7', description: 'This is a s7 page' },
  ];
  const containerStyle = {
    width: '40vw',
    height: '50vh',
    margin: '0 auto',
    padding: '60px',
    marginBottom: '50px',
  };

  smoothscroll.polyfill();

  return (

    
      
    <div className="whole">
      <div className="backpic">
        <div className="whole-nav">
          <div className="left-nav">darshan.n</div>
          <div className="right-nav">
            <div className="about-nav" onClick={() => scrollToSection(aboutMeRef)}>About Me</div>
            <div className="skills-nav" onClick={() => scrollToSection(skillsRef)}>Skills</div>
            <div className="projects-nav" onClick={() => scrollToSection(projectsRef)}>Projects</div>
            <button className="connect-but" onClick={() => scrollToSection(contactRef)}>Let's Connect</button>
          </div>
        </div>



        <div className="center-content" ref={aboutMeRef}>
          <div>
            <span className="myname1" style={{marginBottom: '20px'}}></span>

            <div
            ref={containerRef}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '100%', gap: 0, fontSize: '20px', color: 'white', fontWeight: 'bold', textAlign: 'center'}}
            >
              <VariableProximity
                label={'A 3rd-year Information Technology student at Manipal Institute'}
                className={'variable-proximity-demo'}
                fromFontVariationSettings="'wght' 100, 'opsz' 20" 
                toFontVariationSettings="'wght' 1000, 'opsz' 40"
                containerRef={containerRef}
                radius={100}
                style={{marginTop: '40px'}}
                falloff='linear'
              />
              <VariableProximity
                label={'of Technology (MIT), Manipal. I enjoy transforming'}
                className={'variable-proximity-demo'}
                fromFontVariationSettings="'wght' 100, 'opsz' 20" 
                toFontVariationSettings="'wght' 1000, 'opsz' 40"
                containerRef={containerRef}
                style={{marginTop: '10px'}}
                radius={100}
                falloff='linear'
              />
              <VariableProximity
                label={'creative designs into functional and user-friendly web experiences'}
                className={'variable-proximity-demo'}
                fromFontVariationSettings="'wght' 100, 'opsz' 20" 
                toFontVariationSettings="'wght' 1000, 'opsz' 40"
                containerRef={containerRef}
                radius={100}
                style={{marginTop: '10px'}}
                falloff='linear'
              />
              <p></p>
              <VariableProximity
                label={'Leetcodes solved: 278...'}
                className={'variable-proximity-demo'}
                fromFontVariationSettings="'wght' 400, 'opsz' 9"
                toFontVariationSettings="'wght' 1000, 'opsz' 40"
                containerRef={containerRef}
                radius={100}
                style={{ fontSize: '1.5rem', color: 'white', fontWeight: 'bold', marginTop: '-20px' }}  
                falloff='linear'
              />

            </div>    
          </div>
          <img src={mypic} alt="my pic" className="mypic" />
        </div>
      </div>

      <div ref={skillsRef}>
        <Skills />
      </div>

      <h1 className="projects" ref={projectsRef}>PROJECTS</h1>
      <ShinyText text="1. Survey Form(2020)" disabled={false} speed={3} className='projects-sub' />
      <div style={containerStyle} className="containerStyle">
        <ImageSlider slides={slides2} className="container2" />
      </div>

      <p className="projects-sub">2. UI-Designing(2022)</p>
      <div style={containerStyle} className="containerStyle">
        <ImageSlider slides={slides} className="container1" />
      </div>

      <p className="projects-sub">3. Suggesto(2023)</p>
      <p className="projects-sub">(This project is a web application where users can anonymously share their thoughts, opinions, and messages based on a specific place and type.)</p>
      <div style={containerStyle} className="containerStyle">
        <ImageSlider slides={slides3} className="container1" />
      </div>

      <p className="projects-sub">THREE MORE PROJECTS TO BE ADDED (2 MOBILE APPS, 1 ML PROJECT)</p>
      

      <div ref={contactRef}>
        <Contact />
      </div>

      <hr className="separator" />
      <Footer />
    </div>


  );
};

export default Landing;
